import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";
import { ARTICLES, TREES } from "../data.js";

export default function Home({ v }) {
  return (
    <div style={pstyle("padding:88px 44px 80px; display:flex; flex-direction:column; align-items:center; gap:64px;")}>
      <div style={pstyle("width:100%; max-width:720px; display:flex; flex-direction:column; align-items:center; gap:22px; text-align:center;")}>
        <h1 style={pstyle("margin:0; font-size:40px; font-weight:600; letter-spacing:-0.03em; text-wrap:balance;")}>Que cherchez-vous ?</h1>
        <p style={pstyle("margin:0; font-size:15.5px; line-height:1.6; color:oklch(0.5 0.015 60); max-width:52ch;")}>{ARTICLES.length} fiches et {TREES.length} arbres de dépannage pour ingénieurs réseaux. Réponse en une page, commande incluse.</p>
        <Hoverable
          onClick={v.openSearch}
          style={pstyle("width:100%; display:flex; align-items:center; gap:12px; background:oklch(1 0 0); border:1px solid oklch(0.86 0.01 85); border-radius:10px; padding:15px 18px; font-size:15px; color:oklch(0.55 0.015 60); cursor:pointer;")}
          hoverStyle={{ borderColor: "oklch(0.65 0.02 60)" }}
        >
          <span style={pstyle("overflow:hidden; text-overflow:ellipsis; white-space:nowrap; min-width:0;")}>« route-map », « OSPF LSA type 5 », « show bgp summary »…</span>
          <span style={pstyle("margin-left:auto; flex:none; font-family:'IBM Plex Mono', monospace; font-size:11.5px; border:1px solid oklch(0.9 0.008 85); border-radius:4px; padding:2px 6px;")}>⌘K</span>
        </Hoverable>
        <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap; justify-content:center;")}>
          {v.hotTags.map((t, i) => (
            <Hoverable
              key={i}
              as="span"
              onClick={t.onClick}
              style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; border-radius:999px; padding:5px 12px; cursor:pointer;", { color: t.color, background: t.bg, border: "1px solid " + t.border })}
              hoverStyle={{ filter: "brightness(0.97)" }}
            >
              {t.label}
            </Hoverable>
          ))}
        </div>
      </div>

      <div className="nd-home-groups" style={pstyle("width:100%; max-width:1080px; display:grid; grid-template-columns:repeat(3, 1fr); gap:48px 56px;")}>
        {v.groups.map((g, gi) => (
          <div key={gi} style={pstyle("display:flex; flex-direction:column; gap:11px;")}>
            <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60); border-bottom:1px solid oklch(0.94 0.006 85); padding-bottom:8px;")}>{g.name}</div>
            {g.items.map((it, ii) => (
              <Hoverable
                key={ii}
                onClick={it.onClick}
                style={pstyle("font-size:14px; line-height:1.5; color:oklch(0.3 0.015 60); padding:2px 0; cursor:pointer;")}
                hoverStyle={{ color: g.color }}
              >
                {it.label}
              </Hoverable>
            ))}
          </div>
        ))}
      </div>

      <div className="nd-home-track-row" style={pstyle("width:100%; max-width:1080px; border-top:1px solid oklch(0.94 0.006 85); padding-top:28px; display:flex; gap:56px;")}>
        <div className="nd-home-track-label" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60); width:180px; flex:none; padding-top:4px;")}>Vos parcours</div>
        <div className="nd-home-tracks" style={pstyle("flex:1; display:flex; gap:40px;")}>
          {v.tracks.map((t, i) => (
            <button key={i} type="button" onClick={t.onClick} style={pstyle("background:none; border:none; text-align:left; font:inherit; flex:1; display:flex; flex-direction:column; gap:8px; cursor:pointer;")}>
              <div style={pstyle("display:flex; align-items:baseline; gap:8px; font-size:14px;")}>
                <span>{t.name}</span>
                <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11.5px;", { color: t.color })}>{t.pct}%</span>
              </div>
              <div style={pstyle("height:6px; border-radius:3px; overflow:hidden;", { background: t.soft })}>
                <div style={pstyle("height:100%;", { background: t.color, width: t.pct + "%" })}></div>
              </div>
              <div style={pstyle("font-size:12.5px; color:oklch(0.55 0.015 60);")}>{t.next}</div>
            </button>
          ))}
        </div>
      </div>

      <div className="nd-home-track-row" style={pstyle("width:100%; max-width:1080px; border-top:1px solid oklch(0.94 0.006 85); padding-top:28px; display:flex; gap:56px;")}>
        <div className="nd-home-track-label" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60); width:180px; flex:none; padding-top:4px;")}>Outils</div>
        <div className="nd-home-tools-grid" style={pstyle("flex:1; display:grid; grid-template-columns:repeat(3, 1fr); gap:14px;")}>
          {v.toolLinks.map((t, i) => (
            <Hoverable
              key={i}
              onClick={t.onClick}
              style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; padding:14px 16px; display:flex; flex-direction:column; gap:5px; cursor:pointer;")}
              hoverStyle={{ borderColor: "oklch(0.78 0.014 85)" }}
            >
              <span style={pstyle("font-size:14px; color:oklch(0.26 0.015 60);")}>{t.label}</span>
              <span style={pstyle("font-size:12.5px; line-height:1.5; color:oklch(0.55 0.015 60); text-wrap:pretty;")}>{t.desc}</span>
            </Hoverable>
          ))}
        </div>
      </div>
    </div>
  );
}
